import React from 'react'
import ScrollOut from 'scroll-out'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from "react-router"

import Loading from 'components/Loading'
import Header from './common/Header'
import Footer from './common/Footer'
import VerifyDialog from 'components/dialog/VerifyDialog'
import ForgetPasswordDialog from 'components/dialog/ForgetPasswordDialog'

import { sendResetPasswordEmail } from 'libraries/utils'

import { login, register } from 'actions/asyncMember'

import lineIcon from 'static/images/LINE_SOCIAL_Circle.png'
import bg_5 from 'static/images/bg_5.jpg'
import bg_6 from 'static/images/bg_6.jpg'
import carouselImg from 'static/images/carousel-02.jpg'
import managementImg from 'static/images/management.jpg'
import app_bg from 'static/images/app_bg.jpg'
import step1 from 'static/images/step1.png'
import step2 from 'static/images/step2.png'
import step3 from 'static/images/step3.png'
import step4 from 'static/images/step4.png'
import wine_bg from 'static/images/wine_bg.jpg'

class Home extends React.Component {
    constructor(props) {
        super(props)
        const showLoginPopup = props.location.state === 'loginPopup'
        this.state = {
            action: showLoginPopup ? 'login' : '',
            isOpenVerifyDialog: showLoginPopup,
            isOpenForgotPasswordDialog: false,
        }
    }

    componentDidMount() {
        this.scroll = ScrollOut({
            cssProps: {
                visibleY: true,
                viewportY: true
            }
        })
    }

    componentWillUnmount() {
        this.scroll.teardown();
    }

    handleOnOpenVerifyDialog = (action) => {
        this.setState({
            isOpenVerifyDialog: !this.state.isOpenVerifyDialog,
            action: action || this.state.action
        })
    }

    handleOnSubmit = (type, data) => {
        const { action } = this.state
        if (action === 'login') {
            this.props.login(type, data)
        } else {
            this.props.register(type, data)
        }
    }

    handleActionChange = (action) => {
        this.setState({
            isOpenVerifyDialog: false,
            isOpenForgotPasswordDialog: false,
        })
        if (action === 'forgetpassword') {
            setTimeout(() => {
                this.setState({
                    isOpenForgotPasswordDialog: true,
                })
            }, 200)
        } else {
            setTimeout(() => this.handleOnOpenVerifyDialog(action), 200)
        }
    }

    handleCloseForgotPasswordDialog = () => {
        this.setState({
            isOpenForgotPasswordDialog: false,
        })
    }

    handleForgetPasswordSubmit = (email) => {
        sendResetPasswordEmail(email)
    }

    render() {
        const { isOpenVerifyDialog, isOpenForgotPasswordDialog, action } = this.state

        const TryNowButton = () => (
            <span
                className="btn btn-primary mt-lg-3 mt-2 btn-lg-p btn-sm-p"
                style={{ padding: '6px 36px' }}
                onClick={() => this.handleOnOpenVerifyDialog('login')}
            >立即體驗</span>
        )

        return (
            <div className="home">
                <Header />
                <main role="main">
                    <Loading isLoading={this.props.isLoading} />
                    <div className="fixed-bottom text-right" style={{ right: '20px', bottom: '20px' }}>
                        <a
                            className="line-button d-inline-block pointer"
                            style={{ padding: '5px' }}
                            href="http://nav.cx/em7Bchk"
                            target="_blank"
                            title="加入 line@ 獲得限時免運"
                        >
                            <img src={lineIcon} style={{ height: '60px', objectFit: 'contain' }} alt="icon" />
                        </a>
                    </div>
                    <div className="fix-background">
                        <div className="container" data-scroll="out">
                            <div className="row">
                                <div className="col-md-4">
                                    <h1 className="display-4 font-weight-bold text-white d-inline-block">
                                        CELLWINE
                                    </h1>
                                </div>
                            </div>
                            <div className="row align-items-center">
                                <div className="col-md-4">
                                    <h1 className="display-4 font-weight-bold text-white d-inline-block mt-2">
                                        銅板酒窖
                                    </h1>
                                </div>
                                <div className="col-md-4">
                                    <hr style={{ borderColor: 'white' }} />
                                </div>
                                <div className="col-md-4">
                                    <h5 className="text-white d-inline-block font-weight-light mb-0">
                                        一瓶也能存，輕便價入住專業酒藏
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content-section" data-scroll>
                        <figure className="figure">
                            <img src={bg_5} alt="bg" />
                        </figure>
                        <div className="content">
                            <header className="header">
                                <h1 className="heading">
                                    以瓶計費
                                </h1>
                                <h1 className="subheading font-weight-light">存多少繳多少</h1>
                            </header>
                            <p className="paragraph">
                                CELLWINE 提供市場獨家的<b>以瓶計價的月繳制度</b>
                                <br />
                                揮別付了租金卻放不滿的浪費， 存多少繳多少
                                <br />
                                <br />
                                <TryNowButton />
                            </p>
                        </div>
                    </section>
                    <section className="content-section" data-scroll>
                        <figure className="figure">
                            <img src={bg_6} alt="bg" />
                        </figure>
                        <div className="content">
                            <header className="header">
                                <h1 className="heading">
                                    專業級藏酒空間
                                </h1>
                            </header>
                            <p className="paragraph">
                                適合長期窖藏的適宜溫濕度
                                <br />
                                媲美法國天然酒窖的「窖藏」空間
                                <br />
                                <span style={{ opacity: 0.85 }}>註：14度C ±2 度，相對濕度 70% ±10%</span>
                                <br />
                                <br />
                                <TryNowButton />
                            </p>

                        </div>
                    </section>

                    {/* <section className="content-section" data-scroll>
                        <figure className="figure">
                            <img src={carouselImg} alt="bg" />
                        </figure>
                        <div className="content">
                            <header className="header">
                                <h1 className="heading">
                                    優雅取酒
                                </h1>
                                <h1 className="subheading font-weight-light">
                                    配送到府免運費方案
                            </h1>
                            </header>
                            <p className="paragraph">
                                不再翻箱倒櫃、汗流浹背，只為拿一瓶酒
                                <br />
                                <span className="d-inline-block">月藏36瓶即可享用我們<b>免費</b>送酒服務一次*</span>
                                <br />
                                讓您聰明存酒，輕鬆品酒
                                <br />
                                <br />
                                <small style={{ opacity: 0.5 }}>*每月新增達36瓶儲存數量，回饋乙次免費送酒服務（一次以6瓶為限）</small>
                                <br />
                                <br />
                                <TryNowButton />
                            </p>
                        </div>
                    </section> */}

                    <section className="content-section" data-scroll>
                        <figure className="figure">
                            <img src={managementImg} alt="bg" />
                        </figure>
                        <div className="content">
                            <header className="header">
                                <h1 className="heading">
                                    智能標籤化系統
                                </h1>
                                <h1 className="subheading font-weight-light">
                                    呵護您獨一無二的珍藏
                                </h1>
                            </header>
                            <p className="paragraph">
                                您的愛酒都將擁有獨一無二的QR Code標籤編碼
                                <br />
                                藏酒紀錄同時串連 CELLWINE APP
                                <br />
                                打造真正的科技化葡萄酒管理
                                <br />
                                <br />
                                <TryNowButton />
                            </p>
                        </div>
                    </section>

                    <section className="content-section" data-scroll>
                        <figure className="figure">
                            <img src={app_bg} alt="bg" />
                        </figure>
                        <div className="content">
                            <header className="header">
                                <h1 className="heading">
                                    省錢省空間
                                </h1>
                                <h1 className="subheading font-weight-light">
                                    我們還幫你省腦容量
                                </h1>
                            </header>
                            <p className="paragraph">
                                搭配使用 CELLWINE 智能酒窖 App
                                <br />
                                再也不用擔心買到重複的酒
                                <br />
                                愛酒資訊、國際均價及藏酒數量，全部一手掌握
                                <br />
                                <br />
                                <TryNowButton />
                            </p>
                        </div>
                    </section>

                    <div className="bg-white">
                        <div className="margin-block" id="section2"></div>
                        <div className="margin-block"></div>

                        <div className="container price-area-lg-mt price-area-sm-mt" data-scroll>
                            <div className="row align-items-center row mr-0 ml-0">
                                <div className="col-lg-4 pr-0 pl-0">
                                    <div className="text-center pt-5 pb-5" style={{ backgroundColor: '#47C0BB' }}>
                                        <p className="title-lg title-sm text-white" style={{ marginBottom: 0 }}>儲存費最划算</p>
                                        <p className="title-lg title-sm font-weight-bold text-white">越久越便宜</p>
                                    </div>
                                </div>
                                <div className="col-lg-8 col-12 price-form-section" style={{ backgroundColor: '#ffffff', border: '1px solid #eee' }}>
                                    <div id="normalPrice" className="row p-lg-5 p-4">
                                        <div className="col-lg-3 col-12">
                                            <div className="row">
                                                <div className="col-lg-12 col-6 py-4 text-center border border-white" style={{ backgroundColor: '#f6f6f6' }}>
                                                    <span style={{ fontSize: '16px' }}>入窖當月</span>
                                                </div>
                                                <div className="col-lg-12 col-6 py-4 text-center">
                                                    <div className="font-weight-bold text-secondary" style={{ fontSize: '24px', display: 'inline-block', position: 'relative' }}>
                                                        <del>$20</del>
                                                        <span className="h1" style={{ color: '#e74c39' }}>$0</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-12">
                                            <div className="row">
                                                <div className="col-lg-12 col-6 py-4 text-center border border-white"
                                                    style={{ backgroundColor: '#f6f6f6' }}>
                                                    <span style={{ fontSize: '16px' }}>入窖次月</span>
                                                    <span className="ml-n1" style={{ fontSize: '12px' }}>起</span>
                                                </div>
                                                <div className="col-lg-12 col-6 py-4 text-center">
                                                    <div className="font-weight-bold"
                                                        style={{ fontSize: '24px', display: 'inline-block', position: 'relative' }}>
                                                        $20
                                                        {/* <span
                                                            className="px-2 text-white"
                                                            style={{
                                                                border: 'solid 2px #ffffff',
                                                                borderRadius: '14px',
                                                                whiteSpace: 'nowrap',
                                                                backgroundColor: '#444',
                                                                fontSize: '14px',
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '85%'
                                                            }}>8 折</span> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-12">
                                            <div className="row">
                                                <div className="col-lg-12 col-6 py-4 text-center border border-white"
                                                    style={{ backgroundColor: '#f6f6f6' }}>
                                                    <span style={{ fontSize: '16px' }}>第 13 個月</span>
                                                    <span className="ml-n1" style={{ fontSize: '12px' }}>起</span>
                                                </div>
                                                <div className="col-lg-12 col-6 py-4 text-center">
                                                    <div className="font-weight-bold"
                                                        style={{ fontSize: '24px', display: 'inline-block', position: 'relative' }}>
                                                        $16
                                                        <span
                                                            className="px-2 text-white"
                                                            style={{
                                                                border: 'solid 2px #ffffff',
                                                                borderRadius: '14px',
                                                                whiteSpace: 'nowrap',
                                                                backgroundColor: '#444',
                                                                fontSize: '14px',
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '85%'
                                                            }}>8 折</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="col-lg-3 col-12">
                                            <div className="row">
                                                <div className="col-lg-12 col-6 py-4 text-center border border-white"
                                                    style={{ backgroundColor: '#f6f6f6' }}>
                                                    <span style={{ fontSize: '16px' }}>第 25 個月</span>
                                                    <span className="ml-n1" style={{ fontSize: '12px' }}>起</span>
                                                </div>
                                                <div className="col-lg-12 col-6 py-4 text-center">
                                                    <div className="font-weight-bold"
                                                        style={{ fontSize: '24px', display: 'inline-block', position: 'relative' }}>
                                                        $8
                                                        <span
                                                            className="px-2 text-white"
                                                            style={{
                                                                border: 'solid 2px #ffffff',
                                                                borderRadius: '14px',
                                                                whiteSpace: 'nowrap',
                                                                backgroundColor: '#e74c39',
                                                                fontSize: '14px',
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '92%'
                                                            }}
                                                        >4 折</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="offset-lg-4 col-lg-8 col-10 offset-1">
                                    <div className="text-secondary pt-2">
                                        <small>
                                            *儲存費以每瓶計費。
                                            <br />
                                            *儲存費採每月扣款
                                            <br />
                                            *每次存酒須收取單次處理費，處理費計算採每瓶 20 元。
                                            <br />
                                            <br />
                                            處理費可以幫助 CELLWINE 持續讓您享受更優質的藏酒服務，其中包含酒標辨識系統維運費、倉管服務費、系統資安維護費。
                                            <br />
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="margin-block"></div>
                        <div className="container price-area-lg-mt price-area-sm-mt" data-scroll>
                            <div className="row mr-0 ml-0">

                                <div className="col-lg-8 col-12 price-form-section border p-5 text-center"
                                    style={{ backgroundColor: '#ffffff', border: '1px solid #eee' }}>
                                    <h1 className="free-deliver title-lg font-weight-light">
                                        {/* 存入達 36 瓶享<b>免運</b>乙次 */}
                                    </h1>
                                    <TryNowButton />
                                </div>
                                <div className="col-lg-4 pr-0 pl-0">
                                    <div className="text-center pt-5 pb-5" style={{ backgroundColor: '#47C0BB' }}>
                                        <p className="title-lg title-sm text-white" style={{ marginBottom: 0 }}>聰明存酒</p>
                                        <p className="title-lg title-sm font-weight-bold text-white">輕鬆品酒</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="margin-block"></div>

                    </div>

                    <div className="container-fluid container-padding" style={{ backgroundColor: '#f0f0f0' }}>
                        <div className="row" data-scroll="">
                            <div className="col-md-12 text-center" style={{ marginBottom: '30px' }}>
                                <div className="margin-block"></div>
                                <h1>窖藏四步驟</h1>
                            </div>
                        </div>
                        <div className="timeline-container top-circle">
                            <section className="timeline">
                                <div className="timeline-block" data-scroll>
                                    <div className="timeline-point success">
                                        <i className="glyphicon glyphicon-map-marker"></i>
                                    </div>

                                    <div className="timeline-content">
                                        <div className="social-card share full-width">
                                            <div className="circle" data-toggle="tooltip" title="" data-container="body"
                                                data-original-title="Label">
                                            </div>
                                            <img className="w-100" src={step1} alt="" />
                                        </div>
                                    </div>
                                </div>

                                <div className="timeline-block" data-scroll>
                                    <div className="timeline-point success">
                                        <i className="glyphicon glyphicon-map-marker"></i>
                                    </div>

                                    <div className="timeline-content">
                                        <div className="social-card share full-width">
                                            <div className="circle" data-toggle="tooltip" title="" data-container="body"
                                                data-original-title="Label">
                                            </div>
                                            <img className="w-100" src={step2} alt="" />
                                        </div>
                                    </div>
                                </div>

                                <div className="timeline-block" data-scroll>
                                    <div className="timeline-point success">
                                        <i className="glyphicon glyphicon-map-marker"></i>
                                    </div>

                                    <div className="timeline-content">
                                        <div className="social-card share full-width">
                                            <div className="circle" data-toggle="tooltip" title="" data-container="body"
                                                data-original-title="Label">
                                            </div>
                                            <img className="w-100" src={step3} alt="" />
                                        </div>
                                    </div>
                                </div>

                                <div className="timeline-block" data-scroll>
                                    <div className="timeline-point success">
                                        <i className="glyphicon glyphicon-map-marker"></i>
                                    </div>

                                    <div className="timeline-content">
                                        <div className="social-card share full-width">
                                            <div className="circle" data-toggle="tooltip" title="" data-container="body"
                                                data-original-title="Label">
                                            </div>
                                            <img className="w-100" src={step4} alt="" />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 text-center">
                                        <TryNowButton />
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>

                    <div className="page-parallax wine-management" data-scroll id="section3">
                        <section>
                            <div className="space">
                                <img className="space-bg" src={wine_bg} alt="" />
                                <div className="space-content text-white text-center">
                                    <h1>
                                        最新推出
                                    </h1>
                                    <h1>
                                        怦然心動的紅酒整理魔法
                                    </h1>
                                    <p>
                                        由 CELLWINE 紅酒管家外出整理您的藏酒
                                        <br />
                                        不用秘書，也可以享受客製化標籤編碼
                                        <br />
                                        透過 CELLWINE APP 掌握井然有序的藏酒資料
                                    </p>
                                    <a className="btn btn-primary mt-lg-3 mt-2 btn-lg-p btn-sm-p" style={{ padding: '6px 36px' }}
                                        href="https://line.me/R/ti/p/OJDNYNm9RJ" target="_blank" role="button">
                                        了解更多
                                    </a>
                                </div>
                            </div>
                        </section>
                    </div>
                </main>
                <Footer />
                <VerifyDialog
                    open={isOpenVerifyDialog}
                    onClose={this.handleOnOpenVerifyDialog}
                    onSubmit={this.handleOnSubmit}
                    onActionChange={this.handleActionChange}
                    action={action}
                />
                <ForgetPasswordDialog
                    open={isOpenForgotPasswordDialog}
                    onClose={this.handleCloseForgotPasswordDialog}
                    onActionChange={this.handleActionChange}
                    onSubmit={this.handleForgetPasswordSubmit}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    member: state.member,
    isLoading: state.member.isLoading
})

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
    login,
    register,
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Home))